import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { CompanyOffice } from './company-office';
import { CompanyVendor } from './company-vendor';
import { ExemptVendor } from './exempt-vendor';
import { Vendor } from './vendor';

export class CompanyVendorOffice extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static CompanyVendorOfficeProperties: (
    | {
        property: keyof CompanyVendorOffice;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyVendorOffice;
        type: 'alias';
      }
    | {
        property: keyof CompanyVendorOffice;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyVendorId', type: 'column', dataType: 'number' },
    { property: 'CompanyOfficeId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'CompanyVendor', model: 'CompanyVendor', type: 'association' },
    { property: 'CompanyOffice', model: 'CompanyOffice', type: 'association' },
    { property: 'Vendor', model: 'Vendor', type: 'association' },
    { property: 'ExemptVendor', model: 'ExemptVendor', type: 'association' }
  ];

  static {
    CompanyVendorOffice.CompanyVendorOfficeProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          CompanyVendorOffice.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          CompanyVendorOffice.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          CompanyVendorOffice.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(CompanyVendorOfficeObject: Partial<CompanyVendorOffice>) {
    super();

    CompanyVendorOffice.CompanyVendorOfficeProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = CompanyVendorOfficeObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  CompanyVendorId?: number;
  CompanyOfficeId?: number;
  VendorId?: number | null;
  CompanyId?: number | null;
  createdAt?: Date;
  updatedAt?: Date;

  CompanyVendor?: CompanyVendor;
  CompanyOffice?: CompanyOffice;
  Vendor?: Vendor;
  ExemptVendor?: ExemptVendor;
}
